module.exports = __webpack_public_path__ + "img/swsjp-ico.0c46d7ad.png";